<template>
	<div id="app" :class="{'has-sidebar-open': isAnySidebarOpen}" v-if="!isPending">
		<div class="app-inner" v-if="$route.meta.isAdminPage">
			<AdminTopbar />
			<div class="content">
				<AdminContent />
			</div>
		</div>
		<div class="app-inner" v-else-if="$route.meta.isPartnerPage">
			<PartnerTopbar />
			<div class="content content--partner">
				<PartnerContent />
			</div>
		</div>
		<div class="app-inner" v-else>
			<Topbar v-if="!user" />
			<PartnerTopbar v-if="user" />
			<div
				class="content"
				:class="{
					'content--overlay': isOverlayEnabled,
				}"
			>
				<LeftSidebar />
				<MainContent />
				<RightSidebar />
			</div>
			<GenerateContract v-if="isContractFormOverlayVisible" />
			<GenerateConfiguration v-if="isConfigurationFormOverlayVisible" />
		</div>
	</div>
	<div id="app" class="is-pending" v-else></div>
</template>

<script>
import {mapState} from 'vuex';
import appData from '@/core/data';
import Topbar from '@/components/Topbar';
import LeftSidebar from '@/components/LeftSidebar';
import MainContent from '@/components/MainContent';
import RightSidebar from '@/components/RightSidebar';
import AdminTopbar from '@/components/admin/AdminTopbar';
import AdminContent from '@/components/admin/AdminContent';
import PartnerTopbar from '@/components/partner/PartnerTopbar';
import PartnerContent from '@/components/partner/PartnerContent';
import GenerateContract from '@/components/GenerateContract';
import GenerateConfiguration from '@/components/GenerateConfiguration';

export default {
	name: 'app',
	data() {
		return {
			isPending: true,
		};
	},
	components: {
		AdminTopbar,
		AdminContent,
		PartnerTopbar,
		PartnerContent,
		Topbar,
		LeftSidebar,
		MainContent,
		RightSidebar,
		GenerateContract,
		GenerateConfiguration,
	},
	computed: {
		...mapState(['app']),
		isContractFormOverlayVisible() {
			return this.app.isContractFormOverlayVisible;
		},
		isConfigurationFormOverlayVisible() {
			return this.app.isConfigurationFormOverlayVisible;
		},
		isAnySidebarOpen() {
			return this.app.sidebars.left || this.app.sidebars.right;
		},
		user() {
			return this.$store.state.user;
		},
		isOverlayEnabled() {
			return (
				this.app.isPartnerFormVisible ||
				this.app.isContractFormOverlayVisible ||
				this.app.isConfigurationFormOverlayVisible
			);
		},
	},
	mounted() {
		if (this.isPending) {
			return appData.fetch().then(() => {
				this.isPending = false;
			});
		}
	},
};
</script>
<style lang="scss" scoped>
.is-pending {
	width: 100vw;
	height: 100vh;
	animation-name: pending;
	animation-duration: 1.5s;
	animation-iteration-count: infinite;
}

@keyframes pending {
	0% {
		background-color: #ffffff;
	}
	50% {
		background-color: hsl(221, 73%, 76%);
	}
	100% {
		background-color: #ffffff;
	}
}
</style>
